export default __webpack_public_path__ + "static/media/gotFanTheme.dfb7f5a4.mp3";